var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRequiredFields = function SvgRequiredFields(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "required_fields_svg2__a",
    x1: 75,
    x2: 230.23,
    y1: 245.77,
    y2: 83.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#required_fields_svg2__a",
    id: "required_fields_svg2__c",
    x1: 39.12,
    x2: 194.36,
    y1: 211.37,
    y2: 49.49
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#required_fields_svg2__a",
    id: "required_fields_svg2__d",
    x1: 3.25,
    x2: 158.49,
    y1: 176.97,
    y2: 15.09
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#required_fields_svg2__a",
    id: "required_fields_svg2__e",
    x1: -60.65,
    x2: 94.59,
    y1: 115.68,
    y2: -46.19
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#required_fields_svg2__a",
    id: "required_fields_svg2__f",
    x1: -24.78,
    x2: 130.46,
    y1: 150.08,
    y2: -11.79
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#required_fields_svg2__a",
    id: "required_fields_svg2__g",
    x1: 11.09,
    x2: 166.33,
    y1: 184.48,
    y2: 22.61
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M192.31 184.62H89.73c-4.21 0-7.69-3.49-7.69-7.69s3.49-7.69 7.69-7.69h102.58c4.21 0 7.69 3.49 7.69 7.69s-3.49 7.69-7.69 7.69",
    style: {
      fill: "url(#required_fields_svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.31 112.81H89.73c-4.21 0-7.69-3.49-7.69-7.69s3.49-7.69 7.69-7.69h102.58c4.21 0 7.69 3.49 7.69 7.69s-3.49 7.69-7.69 7.69",
    style: {
      fill: "url(#required_fields_svg2__c)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.31 41H89.73c-4.21 0-7.69-3.49-7.69-7.69s3.49-7.69 7.69-7.69h102.58c4.21 0 7.69 3.49 7.69 7.69S196.51 41 192.31 41",
    style: {
      fill: "url(#required_fields_svg2__d)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.93 51.26c-1.95 0-3.9-.72-5.44-2.26L2.23 38.74c-2.97-2.97-2.97-7.9 0-10.87s7.9-2.97 10.87 0l4.82 4.82L43.26 7.36c2.97-2.97 7.9-2.97 10.87 0s2.97 7.9 0 10.87L23.36 49a7.62 7.62 0 0 1-5.44 2.26Z",
    style: {
      fill: "url(#required_fields_svg2__e)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.93 123.07c-1.95 0-3.9-.72-5.44-2.26L2.23 110.55c-2.97-2.97-2.97-7.9 0-10.87s7.9-2.97 10.87 0l4.82 4.82 25.34-25.34c2.97-2.97 7.9-2.97 10.87 0s2.97 7.9 0 10.87L23.36 120.8a7.62 7.62 0 0 1-5.44 2.26Z",
    style: {
      fill: "url(#required_fields_svg2__f)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.93 194.87c-1.95 0-3.9-.72-5.44-2.26L2.23 182.35c-2.97-2.97-2.97-7.9 0-10.87s7.9-2.97 10.87 0l4.82 4.82 25.34-25.34c2.97-2.97 7.9-2.97 10.87 0s2.97 7.9 0 10.87L23.36 192.6a7.62 7.62 0 0 1-5.44 2.26Z",
    style: {
      fill: "url(#required_fields_svg2__g)",
      strokeWidth: 0
    }
  }));
};
export default SvgRequiredFields;